import classnames from 'classnames';
import * as React from 'react';

interface LoadingSpinnerSimpleProps extends React.HTMLProps<HTMLDivElement> {
	size?: number;
}

export const LoadingSpinnerSimple: React.FC<LoadingSpinnerSimpleProps> = ({
	size,
	className,
}) => {
	return (
		<div
			className={classnames('c-simple-loading-spinner', className)}
			style={size ? { fontSize: `${size}px` } : undefined}
		/>
	);
};

export default LoadingSpinnerSimple;
